import React from "react";
import { DropdownBrowser, ButtonBase } from "@reusejs/react";
import { useRouter } from "next/router";
import { useDispatch, useSelector } from "react-redux";
import { clearBidderAuth } from "store";

const items = [
  {
    label: "Home",
    href: "/",
    active: false,
  },
  {
    label: "Auction Events",
    href: "/auction-events",
    active: false,
  },
  {
    label: "Auction Properties",
    href: "/properties",
    active: false,
  },
  {
    label: "KYC",
    href: "/kyc",
    active: false,
  },
  {
    label: "Documents",
    href: "/documents",
    active: false,
  },
];

export default function BidderSidebar(props: any) {
  const router = useRouter();
  const dispatch = useDispatch();
  const userAttributes = useSelector((state: any) => {
    return state.bidderAuth?.user?.attributes;
  });
  const handleLogout = () => {
    dispatch(clearBidderAuth());
    router.push(`${process.env.NEXT_PUBLIC_WEB_URL}logout`);
  };

  return (
    <>
      {props.sidebar === true && (
        <div className="block lg:hidden h-full bg-red-50 absolute top-16 z-10 w-full">
          <div className="relative bg-white border-b shadow-sm rounded-md">
            <DropdownBrowser
              dropdownBrowserClasses={{
                containerClasses:
                  "border-t dark:border-gray-800 bg-white dark:bg-gray-900 focus:outline-none rounded-md",
              }}
              items={items}
              onClick={(item) => {
                if (item.href !== "#") {
                  router.push(item.href);
                }
              }}
            />
            <div className="border-t">
              <div className="text-gray-400 text-center pt-2">
                {userAttributes && userAttributes[0].value}
              </div>
              <div className="flex justify-center py-3">
                {/* <AuthButtons /> */}
                {/* <div className=" lg:flex flex-row mr-4 items-center rounded"> */}
                <ButtonBase
                  variant="primary"
                  type="submit"
                  label="Logout"
                  onClick={() => handleLogout()}
                  buttonBaseClasses={{
                    font: "text-sm font-medium",
                    backgroundColor: "bg-blue-600 hover:bg-blue-700",
                    textColor: "text-white",
                    border: "any",
                    width: "sm:w-full",
                    padding: "px-2 py-2",
                  }}
                />
                {/* </div> */}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
